import { FC, useContext } from 'react'
import Shipment from '../../../../../types/api/shipment'
import { ShipmentsPageCtx } from '../../../shipments-page'
import ShipmentAdditionalInfoCell from './shipment-additional-info-cell'

interface Props {
    shipment: Shipment
}

/** «Доп.» на странице отгрузок: часть свойств редактируется до отправки в печать */
const ShipmentAdditionalInfoEditableCell: FC<Props> = ({ shipment }) => {
    const { onUpdateShipmentFields } = useContext(ShipmentsPageCtx)

    return (
        <ShipmentAdditionalInfoCell
            shipment={shipment}
            editable={!shipment.print_job}
            onChangePrintWithCurator={value =>
                onUpdateShipmentFields(shipment, { printWithCurator: value })
            }
        />
    )
}

export default ShipmentAdditionalInfoEditableCell
